// extracted by mini-css-extract-plugin
export default {"actionHome":"singleAction_actionHome__hReNo","actionGuest":"singleAction_actionGuest__KxLho","chart":"singleAction_chart__Or10A","correctAction":"singleAction_correctAction__lI9RE"};